<template>
    <nav id="header">
        <div style="margin-left: 10px;margin-right: 10px;width: auto;position: relative;">
            <a class="mobile_logo" href="#/home"><img src="../assets/icon_hope_deer.png" width="100px"/></a>
            <button class="menu-btn" @click="showMenu = !showMenu">
                <span class="bar" :class="{ open: showMenu }"></span>
                <span class="bar" :class="{ open: showMenu }"></span>
                <span class="bar" :class="{ open: showMenu }"></span>
            </button>
        </div>
        <MobileNavBar :visible="showMenu" @close="showMenu = false"/>
    </nav>
</template>

<script>
import MobileNavBar from '@/components/mobileNavBar.vue'

export default {
    name: 'MobileTopNavBar',
    components: { MobileNavBar },
    data() {
        return {
            showMenu: false,
        }
    },
    watch: {
        $route() {
            this.showMenu = false
        },
    },
}
</script>

<style scoped>

#header {
    height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 55;
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #eee;
}

.mobile_logo {
    position: relative;
    float: left;
    display: inline-block;
    z-index: 5;
    padding: 15px 0;
    white-space: nowrap;
    padding-right: 2vw;
}

.menu-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    float: right;
    background: none;
    border: none;
    cursor: pointer;
    padding: 18px 4px;
    margin-right: 4px;
}

.bar {
    display: block;
    width: 24px;
    height: 2px;
    background-color: #333;
    border-radius: 2px;
    transition: all 0.25s ease;
}
</style>
